import { UseQueryResult } from '@tanstack/react-query';
import { CollapseProps, Descriptions, Grid, Typography } from 'antd';
import { AxiosResponse } from 'axios';
import { Dispatch, Fragment, SetStateAction, useState } from 'react';
import CollapseCustom from 'src/components/v2/Collapse';
import { IOvertimeTicket } from 'src/types/hr_ticket/overtimeTicket.type';
import { formatDateTime } from 'src/utils/utils';
import OvertimeTicketDrawer from '../TicketRelativeDrawer/OvertimeTicket/OvertimeTicketDrawer';
import { HRTicketStatusTag } from 'src/components/v2/Tag/TicketStatusTag/TicketStatusTag';
const { Text, Link } = Typography;

export type OpenDrawerType = {
  isOpen: boolean;
  id?: number;
};

const overtimeTicketItems = (
  overtimeTickets: IOvertimeTicket[],
  openDrawer: OpenDrawerType,
  setOpenDrawer: Dispatch<SetStateAction<OpenDrawerType>>,
  colspan: number
): CollapseProps['items'] => {
  return overtimeTickets.map((item) => ({
    key: item.id,
    label: (
      <Descriptions
        layout='horizontal'
        labelStyle={{ width: '135px' }}
        column={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 2 }}
        key={item.id}
      >
        <Descriptions.Item label='Mã'>
          <Link
            onClick={() =>
              setOpenDrawer({
                isOpen: true,
                id: item.id
              })
            }
          >
            {item.code}
          </Link>
        </Descriptions.Item>
        <Descriptions.Item label='Trạng thái'>
          <HRTicketStatusTag
            ticketStatus={item?.ticketStatus}
            erpKey={item?.erpKey}
            isSupervisorConfirmed={item?.isSupervisorConfirmed}
            isConfirm={item?.isConfirm}
            hrConfirmedType={item?.hrConfirmedType}
          />
        </Descriptions.Item>
        <Descriptions.Item label='Người lập phiếu'>
          <Text>{item.createdBy?.fullName}</Text>
        </Descriptions.Item>
        <Descriptions.Item label='Ngày tạo'>
          <Text>{formatDateTime(item?.createdDate)}</Text>
        </Descriptions.Item>
        <Descriptions.Item label='Ghi chú' span={colspan}>
          <Text>{item.note}</Text>
        </Descriptions.Item>
      </Descriptions>
    ),
    className: 'overtime-ticket-collapse-item',
    showArrow: false
  }));
};

export default function OvertimeTicket(
  refOvertimeTicketsForTicketQuery: UseQueryResult<AxiosResponse<IOvertimeTicket[], any>, unknown>
) {
  const [openDrawer, setOpenDrawer] = useState<OpenDrawerType>({
    isOpen: false
  });

  const { useBreakpoint } = Grid;
  const breakpoints = useBreakpoint();
  const colspan = breakpoints.xxl ? 2 : 1;

  return (
    <Fragment>
      {refOvertimeTicketsForTicketQuery?.data?.data && refOvertimeTicketsForTicketQuery?.data?.data.length > 0 && (
        <CollapseCustom
          isFullDefault
          title='Danh sách phiếu tăng ca'
          titleLevel={5}
          isSegmented={false}
          collapsible='disabled'
          items={overtimeTicketItems(
            refOvertimeTicketsForTicketQuery?.data.data || [],
            openDrawer,
            setOpenDrawer,
            colspan
          )}
          expandIconPosition='end'
          className='overtime-ticket-collapse'
        />
      )}

      {openDrawer.id && openDrawer.isOpen && <OvertimeTicketDrawer open={openDrawer} setOpen={setOpenDrawer} />}
    </Fragment>
  );
}
